/** @format */

import { actionTypes } from './actions'
import { accessToken, refreshToken, uid } from '../baseURL'

const initialState = {
  isAuth: !!accessToken,
  stsTokenManager: { accessToken, refreshToken, expirationTime: '' },
  uid,
}

export const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SIGN_IN_SUCCESS:
    case actionTypes.SIGN_UP_SUCCESS:
    case actionTypes.AUTH_SOCIAL_SUCCESS:
      return {
        ...state,
        isAuth: true,
        stsTokenManager: payload.stsTokenManager,
        uid: payload.uid,
      }
    case actionTypes.SIGN_OUT_SUCCESS:
      return { ...initialState, isAuth: false }
    default:
      return state
  }
}
